import IUser from "./services/IUser";

export interface IMessage {
  content: string;
  date?: number;
  sentFromCharity: boolean;
  sent?: boolean;
  delivered?: boolean;
  sending?: boolean;
  error?: ErrorCode;
  senderId?: string;
  donorId?: string;
}

export interface IChat {
  messageList: Array<IMessage>;
  donor: IUser;
}

export enum ErrorCode {
  OPT_OUT = "OPT_OUT",
  INVALID_API_TOKEN = "INVALID_API_TOKEN",
  MISSING_REQUIRED_PARAM = "MISSING_REQUIRED_PARAM",
  INVALID_CONTACT = "INVALID_CONTACT",
  BILLING_ISSUE = "BILLING_ISSUE",
  INVALID_NUMBER = "INVALID_NUMBER",
  CREDIT_LIMIT_REACHED = "CREDIT_LIMIT_REACHED",
  INVALID_TEXT_MESSAGE = "INVALID_TEXT_MESSAGE",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
  EXCEPTION_ERROR = "EXCEPTION_ERROR",
}

function errorMessage(message: IMessage): string {
  switch (message.error) {
    case ErrorCode.BILLING_ISSUE:
      return "Billing Issue";
    case ErrorCode.INVALID_NUMBER:
      return "Invalid Number";
    case ErrorCode.CREDIT_LIMIT_REACHED:
      return "Credit Limit Reached";
    default:
      return "An Error Occured";
  }
}

export function messageStatus(message: IMessage): string {
  if (message.sending) {
    return "Sending...";
  } else if (message.sent) {
    if (message.delivered) {
      return "Delivered";
    } else {
      return "Sent";
    }
  }

  return errorMessage(message);
}

export function canBeForwarded(message: IMessage): boolean {
  switch (message.error) {
    case (ErrorCode.INVALID_NUMBER,
    ErrorCode.BILLING_ISSUE,
    ErrorCode.OPT_OUT,
    ErrorCode.CREDIT_LIMIT_REACHED):
      return true;
    default:
      return false;
  }
}
